import { render } from "./FilteringConfig.vue?vue&type=template&id=9206c89e&scoped=true&ts=true"
import script from "./FilteringConfig.vue?vue&type=script&lang=ts"
export * from "./FilteringConfig.vue?vue&type=script&lang=ts"

import "./FilteringConfig.vue?vue&type=style&index=0&id=9206c89e&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9206c89e"]])

export default __exports__